// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"delta-mini-portable-power-station_productcontent__QEvvT"};